import React, { useEffect, useState } from 'react';
import apiHelper from '../api/ApiHelper';
import './styles/Posts.css';
import { useNavigate } from 'react-router-dom';
import { Article, Category } from './types/ArticleTypes';

const Posts: React.FC = () => {
    const [articles, setArticles] = useState<Article[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const data = await apiHelper.fetchArticles();
                setArticles(data);
                setLoading(false);
            } catch (err) {
                setError('Failed to fetch articles');
                setLoading(false);
            }
        };

        fetchArticles();
    }, []);

    const handleArticleClick = (articleId: string) => {
        navigate(`/article/${articleId}`);
    };

    const handleCategoryClick = (e: React.MouseEvent<HTMLDivElement>, categoryName: string) => {
        e.stopPropagation(); // Prevent triggering article click
        navigate(`/category/${categoryName}`);
    };

    if (loading) {
        return <div className="articles-list">Loading...</div>;
    }

    if (error) {
        return <div className="articles-list">{error}</div>;
    }

    return (
        <div className="articles-list">
            {articles.map(item => (
                <div 
                    key={item.articleId} 
                    className="article"
                    onClick={() => handleArticleClick(item.articleId)}
                >
                    <div className="article-image-container">
                        <img src={item.mainImageUrl} alt={item.title} />
                    </div>
                    <div className="article-content-wrapper">
                        <div 
                            className="category-tag"
                            onClick={(e) => handleCategoryClick(e, item.categoryName)}
                            style={{ cursor: 'pointer' }}
                        >
                            {Category[item.categoryName as keyof typeof Category]}
                        </div>
                        <h2 className="article-title">
                            {item.title}
                        </h2>
                        <div
                            className="article-description"
                            dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Posts;